<style scoped>
.custom-box {
    background-color: #f8f9fa; /* Un gris muy claro */
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 20px;
    transition: all 0.3s ease;
    margin-bottom: 20px;
}

.custom-box:hover {
    border-color: #007bff; /* Se ilumina al pasar el mouse */
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
</style>
<template>
    <div>
        <app-overlay-loader v-if="preloader" />
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog" :class="{ 'loading-opacity': preloader }">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-6"></div>
                            <div class="col-6 text-center">
                                <h3>Cost per Lb</h3>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <SelectSupplier v-model="inputs.supplier" :is_view="is_view"/>
                                <SelectCountry v-model="inputs.country" :is_view="is_view"/>
                                <SelectHttps v-model="inputs.category" :is_view="is_view" label="Category" :required="true" url="/productCategories/serverside/selectable-name" listValueField="name"/>
                                <ProductFeatures v-model="inputs.product_org_conv" :list="orgConvList" :is_view="is_view" label="Org/Conv" />
                                <ProductFeatures v-model="inputs.product_subcategory" :list="SubCategoryList" :is_view="is_view" label="Sub category"  />
                                <ProductDescription v-model="inputs.product" :is_view="is_view"/>
                                <ProductFeatures v-model="inputs.product_feature" :list="featureList" :is_view="is_view" label="Feature" />
                                <ProductFeatures v-model="inputs.product_cutsize" :list="cutSizeList" :is_view="is_view" label="Cut-size" />
                                <ProductFeatures v-model="inputs.product_grade" :list="gradeList" :is_view="is_view" label="Grade" />
                                <ProductFeatures v-model="inputs.product_crop" :list="cropList" :is_view="is_view" label="Crop"/>
                                <Quantity v-model="inputs.quantity" :is_view="is_view"/>
                                <Price v-model="inputs.price" :is_view="is_view"/>
                                <productPack v-model="inputs.productPack" :list="packList" :is_view="is_view" />                   
                                <ProductSize v-model="inputs.productSize" :is_view="is_view"/>
                                <ProductFeatures v-model="inputs.productIncoterm" label="Incoterms" :list="incotermList" :is_view="is_view" />
                                <Shipping v-model="inputs.shipping" :is_view="is_view" />
                                <ProductFeatures v-model="inputs.payment" :list="paymentList" :is_view="is_view" label="Payment"/>
                                <Other v-model="inputs.other" :is_view="is_view"/>
                                <CvValues v-model="inputs.cvForduties" :is_view="is_view" label="CV Value For Duties"/>
                                <CvValues v-model="inputs.cvForTariff" :is_view="is_view" label="CV Value For Tariff"/>
                               
                            </div>
                            <div class="col-6">
                                <CostPerFob v-model="inputs.costPerFob" :is_view="is_view"/>
                                <PurchaseComission v-model="inputs.purchaseComission" :is_view="is_view"/>
                                <Inspections v-model="inputs.inspection" :is_view="is_view"/>
                                <TotalWeight v-model="inputs.payloadLbs" :is_view="is_view"/>
                                <BankCharges v-if="type === 'ocean'" v-model="inputs.bankCharges" :is_view="is_view"/>
                                <OceanDestination v-if="type === 'ocean'" v-model="inputs.oceanDestination" :is_view="is_view"/>
                                <InlandFreight v-model="inputs.inlandFreight" :is_view="is_view"/>
                                <WarehousesCharges v-model="inputs.warehousesCharges" :is_view="is_view" />
                                <CustomsBrokerage v-model="inputs.customsBrokerage" :is_view="is_view" />
                                <CustomBrokerageFinalDestination v-if="type==='truck'" :is_view="is_view" v-model="inputs.customBrokerageFinalDestination" />
                                <RateDuty v-model="inputs.rateDuty" :is_view="is_view" />
                                <RateTariff v-model="inputs.rateTariff" :is_view="is_view" />
                                <HerborMaintenence v-if="type=== 'ocean'" v-model="computedHarbor" :is_view="is_view" />
                                <MerchandiseProcessing v-if="type === 'ocean'" v-model="computedMerchandise" :is_view="is_view" />
                                <Insurance v-if="type === 'ocean'" v-model="computedInsurance" :is_view="is_view"/>
                                <OtherCost v-model="inputs.otherCost" :is_view="is_view"/>
                                <Cost v-model="computedCost" />
                                <CommisionSales v-model="inputs.commisionSales" :is_view="is_view"/>
                                <div class="custom-box"> 
                                    <TotalCost v-model="computedTotalCost"/>
                                 </div> 
                                <ToConvert v-model="computedConvert" :is_view="is_view"/>
                                <Comments v-model="inputs.comment" :is_view="is_view" />
                            </div>
                        </div>  
                        <div class="row">
                            <div class="col-6">
                                <div class="custom-box"> 
                                    <h6 class="text-muted mb-3">Destination Information</h6>
                                    <Customer v-model="inputs.customer" :is_view="is_view"/>
                                    <PriceTerms v-model="inputs.priceTerms" :is_view="is_view" />
                                    <ProductFeatures v-model="inputs.customerIncoterm" label="Incoterms" :list="incotermList" :is_view="is_view" />
                                    <FinalDestination v-model="inputs.selectedfinalDestination" :list="ship_address_list" :read="is_view" /> 
                                    <DescriptionAddress v-model="inputs.descriptionFinalDestination" :read="is_view" />
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit" :disabled="is_view">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

import * as actions from "../../../Config/ApiUrl";
import {FormMixin} from "../../../../core/mixins/form/FormMixin";
import SelectSupplier from './components/SelectSupplier.vue';
import SelectCountry from './components/SelectCountry.vue';
import ProductFeatures from "./components/ProductFeatures.vue";
import Quantity from './components/Quantity.vue';
import Price from './components/Price.vue';
import productPack from './components/Pack.vue';
import ProductSize from './components/ProductSize.vue';
import CostPerFob from './components/CostPerFob.vue';
import CvValues from './components/CvValues.vue';
import ProductDescription from './components/ProductDescription.vue';
import PurchaseComission from './components/PurchaseComission.vue';
import Inspections from './components/Inspections.vue';
import TotalWeight from './components/PayloadLbs.vue';
import BankCharges from './components/BankCharges.vue';
import OceanDestination from './components/OceanDestination.vue';
import InlandFreight from './components/InlandFreight.vue';
import WarehousesCharges from './components/WarehousesCharges.vue';
import Shipping from './components/Shipping.vue';
import CustomsBrokerage from './components/CustomBrokerage.vue';
import RateDuty from './components/RateDuty.vue';
import RateTariff from './components/RateTariff.vue';
import Other from './components/Other.vue';
import HerborMaintenence from './components/HerborMaintenence.vue';
import MerchandiseProcessing from './components/Merchandise.vue';
import Insurance from './components/Insurance.vue';
import OtherCost from './components/OtherCost.vue';
import Cost from './components/Cost.vue';
import CommisionSales from './components/CommisionSales.vue';
import TotalCost from './components/TotalCost.vue';
import ToConvert from './components/ToConvert.vue';
import Comments from './components/Comments.vue';
import Customer from './components/Customer.vue';
import PriceTerms from './components/PriceTerms.vue';
import CustomBrokerageFinalDestination from './components/CustomBrokerageFinalDestination.vue';
import FinalDestination from './components/FinalDestination.vue';
import DescriptionAddress from './components/DescriptionAddress.vue';
import SelectHttps from "./components/SelectHttps.vue";

import { get_data_customTable, get_data_cost, get_ship_address_customer, contactAddress } from './api/api.js';

export default {
    name: "AddOceanCosting",
    mixins: [FormMixin],
    components : {
        SelectSupplier, SelectCountry, SelectHttps, ProductFeatures, Quantity, Price, productPack, ProductSize, CostPerFob, ProductDescription, PurchaseComission, Inspections, TotalWeight, BankCharges,OceanDestination, InlandFreight, WarehousesCharges, Shipping, CustomsBrokerage, RateDuty, RateTariff, Other, HerborMaintenence, MerchandiseProcessing, CvValues, Insurance, OtherCost, Cost, CommisionSales, TotalCost, ToConvert, Comments, Customer, PriceTerms, CustomBrokerageFinalDestination, FinalDestination, DescriptionAddress
    },
    props: {
        type: {
            type: String,
            default: ''
        },
        cost_id : {
            type: Number,
            default: ''
        },
        is_view : {
            type : Boolean,
            default : false,
        },
        is_edit : {
            type : Boolean, 
            default : false,
        },
        is_revision : {
            type : Boolean,
            default : false,
        },
        is_duplicated : {
            type : Boolean,
            default : false,
        },
    },
    data() {
        return {
            isloadinCost : false,
            title : '',
            cropList: [],
            packList: [],
            sizeList : [],
            incotermList : [],
            paymentList : [],
            convertList : [],
            unitList : [],
            orgConvList : [],
            featureList : [],
            cutSizeList : [],
            gradeList : [],
            SubCategoryList : [],
            ship_address_list : [],
            preloader: false,
            inputs : {
                cost_type : this.type,
                supplier : { id : null,  Title : null, BillAddress : null, city : null, state : null, country : null, secondTitle : null, address : null, },
                country: { id: null, name: null, Code: null, },   
                category : {id : null},
                product_org_conv : { id: null, value : null},
                product_subcategory : {id: null, value : null},
                product : { id: null, name: null, }, 
                product_feature : {id: null, value : null},
                product_cutsize : {id: null, value: null},
                product_grade : {id: null, value: null},
                product_crop :{  id: null,  value: null,},
                productIncoterm :{ id: null,  value: null, },
                payment : { id: null,  value: null, },
                customerIncoterm : {id :null, value : null, },
                quantity: null,
                price : { currency : { id: null, Code: null }, value : '', unit : {id:'', code:'', factor:''} },
                productPack : { pack : {id: null,  value: null}, quantity : null}, 
                productSize : { size : {id: null,  code: null, factor: null}, quantity : null},
                shipping : null,
                other: null,
                cvForduties : { value : '',},
                cvForTariff : { value : '', },
                customer : { id: null, Title: null, cityName: null, stateName: null, countryName: null, PostalZipCode : null },    
                priceTerms : { currency : { id: null, Code: null }, value : '', unit : {id:'', code:'', factor:''} } ,
                selectedfinalDestination : null,
                descriptionFinalDestination : [],
                costPerFob : { data : '', value : '' },
                purchaseComission : { data : '', unit : {id:'', code:'', factor:''}, value : '', },
                inspection : { data : '',  value : '', },
                payloadLbs : { data : '', dataTotal : '' },
                bankCharges :{ data : '', value : '',  },
                oceanDestination : { data : '', value : '', },
                inlandFreight : { data : '', value : '', },
                warehousesCharges : { data: null,  value: null,},
                customsBrokerage:{ data : '', value : '',},
                rateDuty : { data : '', value : '', },
                rateTariff : { data : '', value : '', },
                herborMaintenence : { data : '', value : ''},
                merchandiseProcessing :{ data : '', value : ''},
                insurance : { data : '', value : '', factor : ''},
                otherCost : { data : '', unit : {id:'', code:'', factor:''}, value : '', },
                cost : { value : '' },
                commisionSales : { data : '', value : '',},
                totalCost : { value: '' },
                toConvert : { unit: { id:'', code:'', factor:''}, value : '', }, 
                comment : null,
                customBrokerageFinalDestination : { data : '', value : ''},
                factor : null, 
                herbormaintenence_settings_factor : null,
                merchandiseprocessing_settings_factor : null,
                insurance_settings_factor : null,
            }
        };
    },
    computed: {
        computedConvert : {
            get() {
                const totalCost = parseFloat(this.computedTotalCost.value) || 0;
                const conversionFactor = parseFloat(this.inputs.toConvert.unit.factor) || 0;
                const total = totalCost * conversionFactor;
                return {
                    unit : this.inputs.toConvert.unit,
                    value : this.roundExcel(total),
                }; 
            },
            set(newValue) {
                if (newValue) {
                    this.$set(this.inputs.toConvert, 'value', newValue.value);
                    this.$set(this.inputs.toConvert, 'unit', newValue.unit);
                }
            }
        },

        computedTotalCost : {
            get() {
                const netCost = parseFloat(this.computedCost.value) || 0;
                const commisionSales = parseFloat(this.inputs.commisionSales.value) || 0;
                const total = netCost + commisionSales;
                return {
                    value : this.roundExcel(total),
                }; 
            },
            set(newValue) {
                this.$set(this.inputs.totalCost, 'value', newValue.value);
            }
        },

        computedCost: {
            get() {
                const costPerFob = parseFloat(this.inputs.costPerFob.value) || 0;
                const purchaseComission = parseFloat(this.inputs.purchaseComission.value) || 0;
                const inspection = parseFloat(this.inputs.inspection.value) || 0;
                const bankCharges = parseFloat(this.inputs.bankCharges.value) || 0;
                const oceanDestination = parseFloat(this.inputs.oceanDestination.value) || 0;
                const inlandFreight = parseFloat(this.inputs.inlandFreight.value) || 0;
                const warehousesCharges = parseFloat(this.inputs.warehousesCharges.value) || 0;
                const customsBrokerage = parseFloat(this.inputs.customsBrokerage.value) || 0;
                const rateDuty = parseFloat(this.inputs.rateDuty.value) || 0;
                const rateTariff = parseFloat(this.inputs.rateTariff.value) || 0;
                const herborMaintenence = this.type === 'ocean' ? 
                    parseFloat(this.inputs.herborMaintenence.value) || 0
                    : 0;
                const merchandiseProcessing = this.type === 'ocean' ? 
                    parseFloat(this.inputs.merchandiseProcessing.value) || 0
                    : 0;
                const insurance = this.type === 'ocean' ? 
                    parseFloat(this.inputs.insurance.value) || 0
                    : 0;
                const otherCost = parseFloat(this.inputs.otherCost.value) || 0;
                const customBrokerageFinalDestination = parseFloat(this.inputs.customBrokerageFinalDestination.value) || 0;
  
                const total = costPerFob + purchaseComission + inspection + bankCharges + oceanDestination + inlandFreight + warehousesCharges + customsBrokerage + rateDuty + rateTariff + herborMaintenence + merchandiseProcessing + insurance + otherCost + customBrokerageFinalDestination;
                
                // Testing
                // console.log(costPerFob + purchaseComission + inspection + bankCharges + oceanDestination + inlandFreight + warehousesCharges + customsBrokerage + rateDuty + rateTariff + herborMaintenence + merchandiseProcessing + insurance + otherCost + customBrokerageFinalDestination);
                // console.log(`${costPerFob} + ${purchaseComission} + ${inspection} + ${bankCharges} + ${oceanDestination} + ${inlandFreight} + ${warehousesCharges} + ${customsBrokerage} + ${rateDuty} + ${rateTariff} + ${herborMaintenence} + ${merchandiseProcessing} + ${insurance} + ${otherCost} + ${customBrokerageFinalDestination}`);
                // Testing
                
                return {
                    value : this.roundExcel(total),
                }; 
            },
            set(newValue) {
                this.$set(this.inputs.cost, 'value', newValue.value);
            }
        },

        computedHarbor: {
            get() {  
                return {
                    data: this.inputs.herborMaintenence.data,
                    value: this.inputs.herborMaintenence.value
                };
            },
            set(newValue) {
                const nuevoData = parseFloat(newValue.data) || 0;
                const payloadLbs = parseFloat(this.inputs.payloadLbs.data) || 0;
                this.$set(this.inputs.herborMaintenence, 'data', this.roundExcel(nuevoData, 2));

                if (payloadLbs !== 0) {
                    const nuevoValue = nuevoData / payloadLbs;
                    this.$set(this.inputs.herborMaintenence, 'value', this.roundExcel(nuevoValue));
                } 
            }
        },

        computedMerchandise: {
            get() {
                return {
                    data: this.inputs.merchandiseProcessing.data,
                    value: this.inputs.merchandiseProcessing.value
                };
            },
            set(newValue) {
                const nuevoData = parseFloat(newValue.data) || 0;
                const payloadLbs = parseFloat(this.inputs.payloadLbs.data) || 0;

                this.$set(this.inputs.merchandiseProcessing, 'data', this.roundExcel(nuevoData, 2));

                if (payloadLbs !== 0) {
                    const nuevoValue = nuevoData / payloadLbs;
                    this.$set(this.inputs.merchandiseProcessing, 'value', this.roundExcel(nuevoValue));
                }
            }
        },

        computedInsurance: {
            get() {
                return {
                    data: this.inputs.insurance.data,
                    factor : this.inputs.insurance.factor,
                    value: this.inputs.insurance.value
                };
            },
            set(newValue) {
                const nuevoData = parseFloat(newValue.data) || 0;
                const factor = parseFloat(newValue.factor) || 0;
                const payloadLbs = parseFloat(this.inputs.payloadLbs.data) || 0;

                this.$set(this.inputs.insurance, 'data', this.roundExcel(nuevoData, 2));
                this.$set(this.inputs.insurance, 'factor', factor);
                if (payloadLbs !== 0) {
                    const nuevoValue = nuevoData / payloadLbs;
                    this.$set(this.inputs.insurance, 'value', this.roundExcel(nuevoValue));
                }
            }
        },

    },
    methods: {
        intentarCalculoAutomaticoHarbor() {
            const costPerFob = parseFloat(this.inputs.costPerFob.value) || 0;
            const payload = parseFloat(this.inputs.payloadLbs.data) || 0;
            const harborSetting = parseFloat(this.inputs.herbormaintenence_settings_factor) || 0;

            if (costPerFob > 0 && payload > 0 && this.isloadinCost === false) {
                const total = (costPerFob * payload) * (harborSetting / 100);
                // Seteamos los valores iniciales
                this.$set(this.inputs.herborMaintenence, 'data', this.roundExcel(total, 2));
                this.$set(this.inputs.herborMaintenence, 'value', this.roundExcel(total / payload));
            }
        },

        intentarCalculoAutomaticoMerchardise() {
            const costPerFob = parseFloat(this.inputs.costPerFob.value) || 0;
            const payload = parseFloat(this.inputs.payloadLbs.data) || 0;
            const MerchandiseSetting = parseFloat(this.inputs.merchandiseprocessing_settings_factor) || 0;

            if (costPerFob > 0 && payload > 0 && this.isloadinCost === false) {
                const total = (costPerFob * payload) * (MerchandiseSetting / 100);
                
                // Seteamos los valores iniciales
                this.$set(this.inputs.merchandiseProcessing, 'data', this.roundExcel(total, 2));
                this.$set(this.inputs.merchandiseProcessing, 'value', this.roundExcel(total / payload));
            }
        },

        intentarCalculoAutomaticoInsurance() {
            const costPerFob = parseFloat(this.inputs.costPerFob.value) || 0;
            const payload = parseFloat(this.inputs.payloadLbs.data) || 0;
            const oceanDestination = parseFloat(this.inputs.oceanDestination.data) || 0;
            const insuranceSetting = parseFloat(this.inputs.insurance_settings_factor) || 0 ;
            const factor = parseFloat(this.inputs.insurance.factor) || 0;
            if (costPerFob > 0 && payload > 0 && oceanDestination > 0 && factor > 0 && insuranceSetting > 0 && this.isloadinCost === false) {
                const total = (costPerFob * payload + oceanDestination) * (insuranceSetting * factor);
 
                // Seteamos los valores iniciales
                this.$set(this.inputs.insurance, 'data', this.roundExcel(total, 2));
                this.$set(this.inputs.insurance, 'value', this.roundExcel(total / payload));
            }
        },

        validateForm(inputs) {
            if (!inputs.supplier.id) {
                this.$toastr.e("Required Supplier");
                return false;
            }else if(!inputs.country.id){
                this.$toastr.e("Required Country");
                return false;
            }else if(!inputs.category.id){
                this.$toastr.e("Required Category");
                return false;
            }else if(!inputs.product.id){
                this.$toastr.e("Required Product");
                return false;
            }else if(!inputs.quantity){
                this.$toastr.e("Required Loads");
                return false;
            }else if(!inputs.price.currency || !inputs.price.unit || !inputs.price.value){
                this.$toastr.e("Required Price");
                return false;
            }else if(!inputs.productPack.pack.id || !inputs.productPack.quantity){
                this.$toastr.e("Required Pack");
                return false;
            }else if(!inputs.productSize.size.id || !inputs.productSize.quantity){
                this.$toastr.e("Required Size");
                return false;
            }
            // else if( inputs.cvForduties.value === null || inputs.cvForduties.value === '' ){ 
            //     this.$toastr.e("Required CV Value For duties");
            //     return false;
            // }else if( inputs.cvForTariff.value === null || inputs.cvForTariff.value === ''){
            //     this.$toastr.e("Required CV Value For Tariff");
            //     return false;
            // }
            else if(!inputs.customer.id){
                this.$toastr.e("Required Customer");
                return false;
            }
            return true;
        },

        submit() {
            this.preloader = true;
            const inputs = {
                ...this.inputs,
                toConvert : this.computedConvert,
                totalCost : this.computedTotalCost,
                cost : this.computedCost
            }

            if(!this.validateForm(inputs)) {
                this.preloader = false;
                return;
            }

            let fetch = 'save';
            if (this.is_edit) {
                fetch ='update'
            }else if(this.is_revision){
                fetch = 'save_revision';
            }
            this.$emit(fetch, inputs);
        },

        async loadData() {
            this.preloader = true;
            this.isLoading = true;
            this.convertList.push({'id' : '1', 'value' : 'Yes'});
            this.convertList.push({'id' : '2', 'value' : 'No'});
            const promises = [
                this.fetchData("crop"),
                this.fetchData("pack"),
                this.fetchData("incoterm"),
                this.fetchData("payment_term"),
                this.fetchData("org_conv"),
                this.fetchData("sub_category"),
                this.fetchData("Feature"),
                this.fetchData("cut_size"),
                this.fetchData("grade"),
            ];

            if (!this.is_revision && !this.is_edit && !this.is_duplicated) { // si es una edición o una revisión ese valor debe ser el la tabla de costing
                promises.push(this.getCostSetting());
            }

            await Promise.all(promises);
            this.isLoading = false;
            this.preloader = false;
        },

        async getCostSetting() {
            let url = actions.GET_COST_SETTINGS;
            this.axiosGet(url).then(response => {
                if (response.data) {
                    const data = response.data;
                    data.forEach(element => {
                        if (element.name === 'harbor_maintenance_fee') {
                            this.inputs.herbormaintenence_settings_factor = element.value;
                        }
                        if (element.name === 'merchandise_processing_fee') {
                            this.inputs.merchandiseprocessing_settings_factor = element.value;
                        }
                        if (element.name === 'insurance') {
                            this.inputs.insurance_settings_factor = element.value;
                        }
                    });
                }
            }).catch(({response}) => {
                console.log(response);
            });
        },

        async fetchData(customTable) {
            const data = await get_data_customTable(customTable);
            if (customTable === 'crop') this.cropList = data;
            else if(customTable === 'pack') this.packList = data;
            else if(customTable === 'incoterm') this.incotermList = data; 
            else if(customTable === 'payment_term') this.paymentList = data;
            else if(customTable == 'org_conv') this.orgConvList = data;
            else if(customTable == 'sub_category') this.SubCategoryList = data;
            else if(customTable == 'Feature') this.featureList = data;      
            else if(customTable == 'cut_size') this.cutSizeList = data;      
            else if(customTable == 'grade') this.gradeList = data;         
        },

        async loadDataCost(cost_id) {
            const data = await get_data_cost(cost_id);
            if (data) {
                this.inputs = {... data}
            }
        },

        roundExcel(num, decimals = 3) {
            const factor = Math.pow(10, decimals);
            const value = Math.round((num + Number.EPSILON) * factor) / factor;
            return value.toFixed(decimals);
        },

        async fetchCustomerDetails(customerId) { 
			// this.inputs.cud_descriptionCustomer = concatCompany(this.inputs.cud_customer);  
            // const idCustomer = customerId ? customerId : this.inputs.cud_customer.id;
            if (customerId) {
                this.ship_address_list = await get_ship_address_customer(customerId);		 
            }
		},

    },
    async mounted() {    
        if (this.is_edit || this.is_revision || this.is_view || this.is_duplicated) {
            this.isloadinCost = true;
        }
        if (this.type === 'ocean') {
            this.title = 'Add Ocean Cost';
            if (this.is_view) {
                this.title = 'View Ocean Cost';
            }else if(this.is_edit){
                this.title = 'Edit Ocean Cost';
            }else if(this.is_revision){
                this.title = 'Add Revision';
            }else if(this.is_duplicated) {
                this.title = 'Duplicate Cost';
            }
        }else if(this.type === 'truck'){
            this.title = 'Add Trucking Cost';
            if (this.is_view) {
                this.title = 'View Trucking Cost';
            }else if(this.is_edit){
                this.title = 'Edit Trucking Cost';
            }else if(this.is_revision){
                this.title = 'Add Revision';
            }else if(this.is_duplicated){
                this.title = 'Duplicate Cost';
            }
        }
        this.loadData();
        if (this.cost_id) {
            this.loadDataCost(this.cost_id)
        }

        if (this.is_edit || this.is_revision || this.is_duplicated) {            
            setTimeout(() => {
                this.isloadinCost = false;
            }, 2500);
        }
    },

    watch: {
        // Escuchamos el objeto 'inputs'
        inputs: {
            handler(newVal, oldVal) {
                // console.log("Se detectó un cambio en los inputs:");
                // console.log("Nuevo estado:", JSON.parse(JSON.stringify(newVal)));
            },
            deep: true // <--- Esto es lo que permite entrar a los objetos internos
        },
        'inputs.customer.id'(newValue, oldValue) {   
            this.fetchCustomerDetails(newValue);
        },
        "inputs.selectedfinalDestination": {
            async handler(newId, oldId) {
                if (newId) {
                    const selectedAddress = this.ship_address_list.find((address) => address.id === newId);
                    if (selectedAddress) {
                        this.inputs.descriptionFinalDestination = contactAddress(selectedAddress);
                    }
                }  
            },
            immediate: true, // Para que se ejecute de inmediato en caso ya haya un valor
        },
        'inputs.price': function(newVal){
            if (newVal.value) {
                this.inputs.costPerFob.data = newVal.value;
            }
            if (newVal.unit) {
                const newFactor = parseFloat(newVal.unit.factor);
                if (!isNaN(newFactor)) {
                    this.factor = newFactor;
                }
                const value = parseFloat(newVal.value / newVal.unit.factor);
                if ( value && !isNaN(value) && Number.isFinite(value)) {
                    this.inputs.costPerFob.value = this.roundExcel(value, 4);
                }
            }
        },
        'inputs.payloadLbs.data' : function (newVal) {
            const inspection = parseFloat(this.inputs.inspection.data);
            const payloadLbs = parseFloat(newVal);
            if ( !isNaN(inspection) && !isNaN(payloadLbs) ) {
                const value = inspection / payloadLbs;
                if (value) {
                    this.inputs.inspection.value = this.roundExcel(value);
                }
            }else{
                this.inputs.inspection.value = 0;
            }

            const bankCharges = parseFloat(this.inputs.bankCharges.data);
            if ( !isNaN(bankCharges) && !isNaN(payloadLbs) ) {
                const value = bankCharges / payloadLbs;
                this.inputs.bankCharges.value = this.roundExcel(value);
            }else {
                this.inputs.bankCharges.value = 0;
            }

            const oceanDestination = parseFloat(this.inputs.oceanDestination.data);
            if ( !isNaN(oceanDestination) && !isNaN(payloadLbs) ) {
                const value = oceanDestination / payloadLbs;
                this.inputs.oceanDestination.value = this.roundExcel(value);
            }else {
                this.inputs.oceanDestination.value = 0;
            }

            const inlandFreight = parseFloat(this.inputs.inlandFreight.data);
            if ( !isNaN(inlandFreight) && !isNaN(payloadLbs) ) {
                const value = inlandFreight / payloadLbs;
                this.inputs.inlandFreight.value = this.roundExcel(value);
            }else{
                this.inputs.inlandFreight.value = 0;
            }

            const warehousesCharges = parseFloat(this.inputs.warehousesCharges.data);
            if ( !isNaN(warehousesCharges) && !isNaN(payloadLbs) ) {
                const value = warehousesCharges / payloadLbs;
                this.inputs.warehousesCharges.value = this.roundExcel(value);
            }else{
                this.inputs.warehousesCharges.value = 0;
            }

            const customsBrokerage = parseFloat(this.inputs.customsBrokerage.data);
            if ( !isNaN(customsBrokerage) && !isNaN(payloadLbs) ) {
                const value = customsBrokerage / payloadLbs;
                this.inputs.customsBrokerage.value = this.roundExcel(value);
            }else {
                this.inputs.customsBrokerage.value = 0;
            }

            const customBrokerageFinalDestination = parseFloat(this.inputs.customBrokerageFinalDestination.data);
            if ( !isNaN(customBrokerageFinalDestination) && !isNaN(payloadLbs) ) {
                const value = customBrokerageFinalDestination / payloadLbs;
                this.inputs.customBrokerageFinalDestination.value = this.roundExcel(value);
            }else {
                this.inputs.customBrokerageFinalDestination.value = 0;
            }

            const herborMaintenence = parseFloat(this.inputs.herborMaintenence.data);
            if ( !isNaN(herborMaintenence) && !isNaN(payloadLbs) ) {
                const value = herborMaintenence / payloadLbs;
                this.inputs.herborMaintenence.value = this.roundExcel(value);
            }else {
                this.inputs.herborMaintenence.value = 0;
            }

            const merchandiseProcessing = parseFloat(this.inputs.merchandiseProcessing.data);
            if ( !isNaN(merchandiseProcessing) && !isNaN(payloadLbs) ) {
                const value = merchandiseProcessing / payloadLbs;
                this.inputs.merchandiseProcessing.value = this.roundExcel(value);
            }else{
                this.inputs.merchandiseProcessing.value = 0;
            }

            const insurance = parseFloat(this.inputs.insurance.data);
            if ( !isNaN(insurance) && !isNaN(payloadLbs) ) {
                const value = insurance / payloadLbs;
                this.inputs.insurance.value = this.roundExcel(value);
            }else{
                this.inputs.insurance.value = 0;
            }

            this.intentarCalculoAutomaticoHarbor(); 
            this.intentarCalculoAutomaticoMerchardise(); 
            this.intentarCalculoAutomaticoInsurance();
        },

        'inputs.inspection' : function (newVal) {
            const inspection = parseFloat(newVal.data) ;
            const payloadLbs = parseFloat(this.inputs.payloadLbs.data);
            if ( !isNaN(inspection) && !isNaN(payloadLbs)) {
                const value = inspection / payloadLbs;
                if (value) {
                    this.inputs.inspection.value = this.roundExcel(value);
                }
            }else{
                this.inputs.inspection.value = 0;
            }
        },

        // para el calculo de payload lbs
        'inputs.quantity' : function (newVal) {
            const quantity = parseFloat(newVal);
            const pack = parseFloat(this.inputs.productPack.quantity);
            const size = parseFloat(this.inputs.productSize.quantity * this.inputs.productSize.size.factor);
            if ( !isNaN(quantity) && !isNaN(pack) && !isNaN(size) ) {
                const value = pack * size * 1;
                const valueTotal = pack * size * quantity;
                this.inputs.payloadLbs.data = this.roundExcel(value);
                this.inputs.payloadLbs.dataTotal = this.roundExcel(valueTotal);
            }else{
                this.inputs.payloadLbs.data = 0;
                this.inputs.payloadLbs.dataTotal = 0;
            }
        },

        'inputs.productPack' : function (newVal) {
            const pack = parseFloat(newVal.quantity);
            const quantity = parseFloat(this.inputs.quantity);
            const size = parseFloat(this.inputs.productSize.quantity * this.inputs.productSize.size.factor);
            if ( !isNaN(quantity) && !isNaN(pack) && !isNaN(size) ) {
                const value = pack * size * 1;
                const valueTotal = pack * size * quantity;
                this.inputs.payloadLbs.data = this.roundExcel(value);
                this.inputs.payloadLbs.dataTotal = this.roundExcel(valueTotal);
            }else{
                this.inputs.payloadLbs.data = 0;
                this.inputs.payloadLbs.dataTotal = 0;
            }
        },

        'inputs.productSize' : function (newVal) {
            const size = parseFloat(newVal.quantity * newVal.size.factor);
            const pack = parseFloat(this.inputs.productPack.quantity);
            const quantity = parseFloat(this.inputs.quantity);
            if ( !isNaN(quantity) && !isNaN(pack) && !isNaN(size) ) {
                const value = pack * size * 1;
                const valueTotal = pack * size * quantity;
                this.inputs.payloadLbs.data = this.roundExcel(value);
                this.inputs.payloadLbs.dataTotal = this.roundExcel(valueTotal);
            }else{
                this.inputs.payloadLbs.data = 0;
                this.inputs.payloadLbs.dataTotal = 0;
            }
        },

        // para el calculo de bank charges 
        'inputs.bankCharges' : function(newVal) {
            const bankCharges = parseFloat(newVal.data);
            const payloadLbs = parseFloat(this.inputs.payloadLbs.data);
            if ( !isNaN(bankCharges) && !isNaN(payloadLbs) ) {
                const value = bankCharges / payloadLbs;
                this.inputs.bankCharges.value = this.roundExcel(value);
            }else{
                this.inputs.bankCharges.value = 0;
            }
        },

        // calculo for Ocean Freight
        'inputs.oceanDestination' : function(newVal) {
            const oceanDestination = parseFloat(newVal.data);
            const payloadLbs = parseFloat(this.inputs.payloadLbs.data);
            if ( !isNaN(oceanDestination) && !isNaN(payloadLbs) ) {
                const value = oceanDestination / payloadLbs;
                this.inputs.oceanDestination.value = this.roundExcel(value);
            }else{
                this.inputs.oceanDestination.value = 0;
            }
        },

        // Calculo de inland freight
        'inputs.inlandFreight' : function (newVal) {
            const inlandFreight = parseFloat(newVal.data);
            const payloadLbs = parseFloat(this.inputs.payloadLbs.data);
            if ( !isNaN(inlandFreight) && !isNaN(payloadLbs) ) {
                const value = inlandFreight / payloadLbs;
                this.inputs.inlandFreight.value = this.roundExcel(value);
            }else{
                this.inputs.inlandFreight.value = 0;
            }
        },

        // Calculo de warehouses charges
        'inputs.warehousesCharges' : function (newVal) {
            const warehousesCharges = parseFloat(newVal.data);
            const payloadLbs = parseFloat(this.inputs.payloadLbs.data);
            if ( !isNaN(warehousesCharges) && !isNaN(payloadLbs) ) {
                const value = warehousesCharges / payloadLbs;
                this.inputs.warehousesCharges.value = this.roundExcel(value);
            }else{
                this.inputs.warehousesCharges.value = 0;
            }
        },

        // Calculo for customer brokerage 
        'inputs.customsBrokerage' : function(newVal){
            const customsBrokerage = parseFloat(newVal.data);
            const payloadLbs = parseFloat(this.inputs.payloadLbs.data);
            if ( !isNaN(customsBrokerage) && !isNaN(payloadLbs) ) {
                const value = customsBrokerage / payloadLbs;
                this.inputs.customsBrokerage.value = this.roundExcel(value);
            }else{
                this.inputs.customsBrokerage.value = 0;
            }
        },

        'inputs.customBrokerageFinalDestination' : function(newVal){
            const customBrokerageFinalDestination = parseFloat(newVal.data);
            const payloadLbs = parseFloat(this.inputs.payloadLbs.data);
            if ( !isNaN(customBrokerageFinalDestination) && !isNaN(payloadLbs) ) {
                const value = customBrokerageFinalDestination / payloadLbs;
                this.inputs.customBrokerageFinalDestination.value = this.roundExcel(value);
            }else{
                this.inputs.customBrokerageFinalDestination.value = 0;
            }
        },

        'inputs.insurance.factor' : function (newVal) {
            const insurance = parseFloat(newVal.data);
            const payloadLbs = parseFloat(this.inputs.payloadLbs.data);
            if ( !isNaN(insurance)  && !isNaN(payloadLbs) ) {
                const value = insurance / payloadLbs;
                this.inputs.insurance.value = this.roundExcel(value);
            }else{
                this.inputs.insurance.value = 0;
            }
            this.intentarCalculoAutomaticoInsurance();
        },

        'inputs.otherCost' : function (newVal) {
            const { data, unit } = newVal;
            const convertion = unit.factor;
            if (data && convertion) {
                const dataConvertion = data / convertion;
                this.inputs.otherCost.value = this.roundExcel(dataConvertion);
            }
        },

        // Commision sales 
        'inputs.commisionSales' : function (newVal) {
            const commisionSales = parseFloat(newVal.data);
            const priceCustomer = parseFloat(this.inputs.priceTerms.value);
            if ( !isNaN(commisionSales) && !isNaN(priceCustomer) ) {
                const value = (priceCustomer * commisionSales) / 100;
                this.inputs.commisionSales.value = this.roundExcel(value);
            }else{
                this.inputs.commisionSales.value = 0;
            }
        },

        'inputs.priceTerms' : function (newVal) {
            const priceCustomer = parseFloat(newVal.value);
            const commisionSales = this.inputs.commisionSales.data;
            if ( !isNaN(commisionSales) && !isNaN(priceCustomer) ) {
                const value = (priceCustomer * commisionSales) / 100;
                this.inputs.commisionSales.value = this.roundExcel(value);
            }else{
                this.inputs.commisionSales.value = 0;
            }
        },

        // commision purchases 
        'inputs.purchaseComission' : function(newVal) {
            const { data, unit } = newVal;
            const convertion = unit.factor;
            if (data && convertion) {
                const dataConvertion = data / convertion;
                this.inputs.purchaseComission.value = this.roundExcel(dataConvertion);
            }
        },

        // Rate of dutty
        'inputs.rateDuty' : function(newVal) {
            const { data  } = newVal;
            const valueForDuties = this.inputs.cvForduties.value;
            if ( data && valueForDuties ) {
                const dataConvertion = data * valueForDuties;
                const newValue = dataConvertion / 100;
                this.inputs.rateDuty.value = this.roundExcel(newValue);
            }
        },

        'inputs.cvForduties' : function(newVal) {
            const { value  } = newVal;
            const rateOfDuty = this.inputs.rateDuty.data;
            if ( value && rateOfDuty ) {
                const dataConvertion = value * rateOfDuty;
                const newValue = dataConvertion / 100;
                this.inputs.rateDuty.value = this.roundExcel(newValue);
            }
        },

        // Rate of tariff
        'inputs.rateTariff' : function(newVal) {
            const { data  } = newVal;
            const cvForTariff = this.inputs.cvForTariff.value;
            if ( data && cvForTariff ) {
                const dataConvertion = data * cvForTariff;
                const newValue = dataConvertion / 100;
                this.inputs.rateTariff.value = this.roundExcel(newValue);
            }
        },

        'inputs.cvForTariff' : function(newVal) {
            const { value  } = newVal;
            const rateOfTariff = this.inputs.rateTariff.data;
            if ( value && rateOfTariff ) {
                const dataConvertion = value * rateOfTariff;
                const newValue = dataConvertion / 100;
                this.inputs.rateTariff.value = this.roundExcel(newValue);
            }
        },

        /* habor */
        'inputs.costPerFob.value': function() { 
            this.intentarCalculoAutomaticoHarbor(); 
            this.intentarCalculoAutomaticoMerchardise(); 
            this.intentarCalculoAutomaticoInsurance();
        },

        'inputs.oceanDestination.data' : function() {
            this.intentarCalculoAutomaticoInsurance();
        },
    },
};
</script>
  